import React from 'react'
import { SpookySkeleton } from '@offerzen/pinata'

import SkeletonJobCard from '../JobCard/SkeletonJobCard'

import styles from './styles'

const SkeletonJobList = () => (
  <SpookySkeleton>
    <span className={styles.accessiblyHidden}>Loading</span>
    <div className={styles.list}>
      <For each="card" of={[0, 1, 2, 3, 4]}>
        <SkeletonJobCard key={card} />
      </For>
    </div>
  </SpookySkeleton>
)

export default SkeletonJobList
